// https://stackoverflow.com/questions/17648014/how-can-i-use-an-angularjs-filter-to-format-a-number-to-have-leading-zeros
angular.module("avlib").filter('avLeadingZeros', function () {
    return function(a,b){
    	if (a !== null){
    		a = ""+a;
    		while (a.length < b) a = "0"+a;
    		return a;
    	}
    	return "";
    };
});